// Animações da mesa: cartas sendo dadas e carta voando até a mesa. Tempos do protótipo, um pouco
// mais curtos que a espera do servidor (ANIMACAO), para a mão estar pronta quando a vez começar.
import { ANIMACAO } from '@truco6/mesa/protocolo';
import type { Ponto } from './geometria.ts';

export const DISTRIBUIR = { embaralhar: 800, passo: 110, voo: 440 } as const;
export const DURACAO_DISTRIBUICAO = DISTRIBUIR.embaralhar + 17 * DISTRIBUIR.passo + DISTRIBUIR.voo + 100;
export const PAUSA_RODADA = ANIMACAO.pausaRodada;
export const RECOLHER = 380; // as cartas da rodada deslizam para quem levou no fim da pausa

export function movimentoReduzido(): boolean {
  return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// Uma carta virada voa do monte até um lugar. A caixa é um div que o React não desenha.
export function voarCarta(caixa: HTMLElement, src: string, de: Ponto, para: Ponto, escala: number, aoChegar: () => void): void {
  const f = document.createElement('img');
  f.className = 'flying';
  f.src = src;
  f.alt = '';
  f.style.left = de[0] - 17 + 'px';
  f.style.top = de[1] - 24 + 'px';
  caixa.appendChild(f);
  let feito = false;
  const fim = () => { if (feito) return; feito = true; f.remove(); aoChegar(); };
  if (typeof f.animate !== 'function') { fim(); return; }
  const giro = Math.round(Math.random() * 50 - 25);
  const a = f.animate([
    { transform: 'translate(0,0) rotate(0deg) scale(1)' },
    { transform: `translate(${para[0] - de[0]}px,${para[1] - de[1]}px) rotate(${giro}deg) scale(${escala})` },
  ], { duration: DISTRIBUIR.voo, easing: 'cubic-bezier(.25,.7,.3,1)', fill: 'forwards' });
  a.onfinish = fim;
  a.oncancel = fim;
}
